export default "__VITE_ASSET__CeDPLj2L__"